export interface PaletteCommand {
  id: string;
  label: string;
  group: string;
  href: string;
}

export const DESK_COMMAND_ACTIONS: PaletteCommand[] = [
  { id: 'new-booking', label: 'New booking', group: 'Actions', href: '#action-new-booking' },
  { id: 'new-client', label: 'New client', group: 'Actions', href: '#action-new-client' },
  { id: 'check-in', label: 'Check in', group: 'Actions', href: '#handover' },
  { id: 'open-caisse', label: 'Open caisse', group: 'Actions', href: '#caisse' },
];

const BLOCKED_COMMAND = ['delete', 'pause', 'suspend', 'sign-out', 'logout'];

export function isSafeCommand(href: string): boolean {
  const value = href.toLowerCase();
  return BLOCKED_COMMAND.every((word) => !value.includes(word));
}

export function paletteResults<Entry extends { label: string; group: string }>(entries: readonly Entry[], query: string): Entry[] {
  const needle = query.trim().toLowerCase();
  if (!needle) {
    const actions = entries.filter((entry) => entry.group === 'Actions');
    if (actions.length > 0) return actions.slice(0, 12);
    return entries.filter((entry) => entry.group === 'Pages').slice(0, 12);
  }
  return entries.filter((entry) => entry.label.toLowerCase().includes(needle)).slice(0, 12);
}

export function movePaletteIndex(current: number, length: number, key: 'ArrowDown' | 'ArrowUp'): number {
  if (length <= 0) return 0;
  if (key === 'ArrowDown') return Math.min(length - 1, current + 1);
  return Math.max(0, current - 1);
}
